<template>
  <el-dialog
    :title="title"
    :visible="isVisible"
    append-to-body
    class="ui-dialog"
    :custom-class="customClass"
    @close="handlerClose">
    <div v-loading="isLoading" class="ui-dialog__body-wrap">
      <div class="ui-dialog__content">
        <!-- TODO SLOT DEFAULT -->
        <slot name="default">
          <div v-html="text"></div>
        </slot>
      </div>
      <div class="ui-dialog__footer">
        <!-- TODO SLOT FOOTER -->
        <slot name="footer"></slot>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UIDialog',
  props: {
    title: { type: String, default: '' },
    isVisible: { type: Boolean, default: false },
    text: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    customClass: { type: String, default: '' }
  },
  methods: {
    handlerClose () {
      this.$emit('update:isVisible', false)
      this.$emit('close')
    }
  }
}
</script>
<style lang="stylus">
  .ui-dialog{
    &__body-wrap{
      height 100%
      display flex
      flex-direction column
    }
    &__content{
      flex 1
    }
    &__footer{
      margin-top 2rem
    }
  }
</style>
